/**
 * Camera and screen share require a secure browser context (HTTPS, or localhost).
 */
export function hasMediaDevices(): boolean {
  return typeof navigator !== "undefined" && !!navigator.mediaDevices;
}

/**
 * Redirect common local dev hostnames from HTTP to HTTPS so media APIs are available.
 */
export function maybeRedirectToSecureMediaContext(): void {
  if (typeof window === "undefined" || window.isSecureContext) return;

  const { protocol, hostname, port, pathname, search, hash } = window.location;
  if (protocol !== "http:") return;

  const needsHttps =
    hostname === "local.revolt.chat" ||
    hostname.endsWith(".local.revolt.chat");

  if (!needsHttps) return;

  const portSuffix = port ? `:${port}` : "";
  window.location.replace(
    `https://${hostname}${portSuffix}${pathname}${search}${hash}`,
  );
}

export function mediaDevicesUnavailableMessage(): string {
  const { protocol, hostname, port } = window.location;
  const portSuffix = port ? `:${port}` : "";

  if (protocol === "http:" && hostname !== "localhost" && hostname !== "127.0.0.1") {
    return `Camera and screen share need a secure connection.

Use https://${hostname}${portSuffix} and accept the certificate warning, or open http://localhost${portSuffix} instead.`;
  }

  return "Camera and screen share are not available in this browser context. Use HTTPS or localhost.";
}

export function requireMediaDevices(): void {
  if (hasMediaDevices()) return;
  throw new Error(mediaDevicesUnavailableMessage());
}
